export interface AppointmentTypeQuestionAnswer {
  answerId?: string;
  answerText?: string;
}

export interface AppointmentTypeQuestion {
  questionId?: string;
  questionText?: string;
  required: boolean;
  fieldSeq: number;
  groupSeq: number;
  answerType?: string;
  answerDefault?: string;
  answerList?: AppointmentTypeQuestionAnswer[];
}

///////////////////////////////////////////////
// defaults for testing
const answerList = new Array(4).fill(undefined).map((item, index) => ({
  answerId: `answer${index}`,
  answerText: `Answer Text ${index}`,
}));

export const DefaultTestQuestionList = new Array(4)
  .fill(undefined)
  .map((item, index) => ({
    questionId: `question${index}`,
    questionText: `Question text ${index}?`,
    required: true,
    fieldSeq: 0,
    groupSeq: 0,
    answerType: undefined,
    answerDefault: index !== 1 ? 'answer1' : undefined,
    answerList: answerList,
  }));
